import useSWR from "swr";
import { getAllBlobInformation } from "../services/file-explorer-service";
import { FolderSummary, UseFileExplorerModel } from "../types";
import { toFolderSummary } from "../utils/folder-summary";

export const FILE_EXPLORER_KEY = "/file-explorer";

export const useFileExplorer = (): UseFileExplorerModel => {
  const { data, error, mutate } = useSWR(
    FILE_EXPLORER_KEY,
    getAllBlobInformation,
  );

  const folders: FolderSummary[] | undefined = data?.folders
    ? data.folders.map(toFolderSummary)
    : undefined;

  return {
    folders,
    isLoading: !error && !data,
    error,
    mutate,
  };
};
